import { useTranslation } from 'react-i18next'

import {
  EMPTY_LIST,
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ActionSelect } from '../../Action'
import { ButtonIconSelectControl } from '../../Select'
import { TableExportButton } from '../TableExportButton'

import { QA_NAME_EXPORT_TABLE_MODAL_EXPORT_MENU } from './TableExportData.constants'

import * as styles from './TableExportData.module.css'

function TableExportData({
  actions = EMPTY_LIST,
  buttonProps: {
    disabledTooltip:
      buttonDisabledTooltip = 'Table.ExportTableButtonDisabledTooltipKey',
    tooltip: buttonTooltip,
    ...buttonProps
  } = EMPTY_OBJECT,
  containerRef,
  disabled,
  isSkeleton,
  qaName = QA_NAME_EXPORT_TABLE_MODAL_EXPORT_MENU,
  title = 'Table.ExportTableDataKey',
  onClickAction,
  ...restProps
}) {
  const { t } = useTranslation()

  return actions.length > 0 ? (
    <ActionSelect
      {...restProps}
      Control={ButtonIconSelectControl}
      actions={actions}
      className={styles.TableExportData}
      controlProps={{
        Button: TableExportButton,
        buttonProps: {
          ...buttonProps,
          isSkeleton,
          text: t(title),
        },
      }}
      dropdownFloatingConfig={{
        containerRef,
        placement: FLOATING_ELEMENT_PLACEMENT.bottom,
      }}
      onClickAction={onClickAction}
    />
  ) : (
    <TableExportButton
      {...restProps}
      {...buttonProps}
      disabled={disabled}
      isSkeleton={isSkeleton}
      qaName={qaName}
      text={t(title)}
      tooltip={disabled ? t(buttonDisabledTooltip) : buttonTooltip}
    />
  )
}

export default TableExportData
